import { ReactElement, ReactNode, useEffect, useRef } from 'react';

interface Props {
  children: ReactElement | ReactNode;
  onOutsideClick: () => void;
}

export const OutsideClickDetector = ({ children, onOutsideClick }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (ref?.current && !ref?.current?.contains(event?.target as Node)) {
        onOutsideClick();
      }
    };
    document?.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document?.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [onOutsideClick]);

  return <div ref={ref}>{children}</div>;
};
